function cctv_group_append(station_name, url_string, url_type, order, is_police = false) {

	if (is_police) {
		// const image_size = { width: 600, height: 400 }

		console.log("[cctv_group_append] police branch, is_police=" + is_police)
		console.log("[cctv_group_append] url_string=" + url_string)
		var police_url = url_string;
		console.log("police_url:", police_url)
		var _public_path = "https://www.edp-dws.ntpc.gov.tw"
		var police_abs_url = _public_path + police_url
		console.log("police_abs_url:", police_abs_url)


		let title = `#cctv-order-${order}`, container = `#cctv-container-${order}`
		$(title + ' h4').remove()

		// 🔹 取得 m3u8Url
		fetchPoliceCCTVUrlWithRetry(police_abs_url, 5, 500)
			.then(m3u8Url => {
				// let m3u8Url = url_string
				console.log("[cctv_dialog - Police] ✅ 成功取得 m3u8Url:", m3u8Url);

				// 	// 🔹 iframe 內容使用 srcdoc 注入 Hls.js 播放器
				const iframeContent = `
			<video id="video" controls autoplay width="100%" height="100%" style="object-fit:contain;"></video>
			<script src="https://cdn.jsdelivr.net/npm/hls.js@latest"><\/script>
			<script>
				var videoSrc = "${m3u8Url}";
				var video = document.getElementById("video");

				if (Hls.isSupported()) {
				var hls = new Hls();
				hls.attachMedia(video);
				hls.on(Hls.Events.MEDIA_ATTACHED, function () {
					hls.loadSource(videoSrc);
				});
				hls.on(Hls.Events.ERROR, function (event, data) {
					console.error("HLS Error:", data);
				});
				} else if (video.canPlayType("application/vnd.apple.mpegurl")) {
				video.src = videoSrc;
				video.addEventListener("loadedmetadata", function() {
					video.play();
				});
				}
			<\/script>
		`;

				// 🔹 將 iframe 注入 content，替換掉載入中
				// const viewHtml = `<iframe id="iframe_${randomId}" srcdoc='${iframeContent}' width="${image_size.width}" height="${image_size.height}" frameborder="0" allowfullscreen></iframe>`;
				const viewHtml = `<iframe id="cctv_group_for_police" srcdoc='${iframeContent}' width="100%" height="100%" frameborder="0" title="CCTV檢視" allowfullscreen></iframe>`;

				$(container).html(`
				<div class="overflow-hidden w-100 h-100">
					${viewHtml}
				</div>`
				)
				$(title + ' h6').text(station_name)
				$(title + ' button').removeClass('d-none')
			})
			.catch(error => {
				console.error("[cctv_dialog - Police] 🚫 獲取 m3u8Url 時發生錯誤:", error);
				content.textContent = "來源端異常，載入失敗，請稍後再試";
			});


	} else {

		let title = `#cctv-order-${order}`, container = `#cctv-container-${order}`
		$(title + ' h4').remove()
		var viewHtml = url_type === 'image' ? `<img src="${url_string}" class="w-100">` :
			`<iframe src="${url_string}" width="100%" height="100%" frameborder="0" title="CCTV檢視"></iframe>`
		$(container).html(`
		<div class="overflow-hidden w-100 h-100">
			${viewHtml}
		</div>`
		)
		$(title + ' h6').text(station_name)
		$(title + ' button').removeClass('d-none')
	}
}

// for 警察局 CCTV 重試 GET m3u8Url
function fetchPoliceCCTVUrlWithRetry(url, retries = 3, delay = 1000) {
	return new Promise((resolve, reject) => {
		function attempt(tryCount) {
			console.log(`第 ${tryCount} 次嘗試取得 m3u8Url...`);

			fetch(url)
				.then(response => {
					if (!response.ok) {
						throw new Error(`HTTP 狀態碼錯誤: ${response.status}`);
					}
					return response.text();
				})
				.then(resText => {
					console.log("fetch res:", resText);

					const match = resText.match(/<body[^>]*id=["']([^"']+)["']/i);
					if (match && match[1]) {
						const m3u8Url = match[1];
						console.log("✅ 成功取得 m3u8Url:", m3u8Url);
						resolve(m3u8Url);
					} else {
						throw new Error("❌ 找不到 CCTV 串流網址");
					}
				})
				.catch(error => {
					console.warn(`⚠️ 第 ${tryCount} 次失敗:`, error.message);
					if (tryCount < retries) {
						console.log(`⏳ ${delay}ms 後重試...`);
						setTimeout(() => attempt(tryCount + 1), delay);
					} else {
						console.error("🚫 已達最大重試次數，放棄。");
						reject(error);
					}
				});
		}

		attempt(1); // 從第一次開始
	});
}

// 警察局 CCTV 專用 dialog 流程直接切分出來 降低耦合度
function cctv_dialog_for_police(dialog_name, url_string) {

	var randomId = createRandomId(5)
	const image_size = { width: 600, height: 400 }

	console.log("cctv_dialog police branch")
	var police_url = url_string;
	console.log("police_url:", police_url)
	var _public_path = "https://www.edp-dws.ntpc.gov.tw"
	var police_abs_url = _public_path + police_url
	console.log("police_abs_url:", police_abs_url)

	// 🔹 先建立 Dialog 主容器
	const parent = document.getElementById("cctv_dialog");
	const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
	const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
	const dialogueWidth = image_size.width + 20;
	const dialogueHeight = image_size.height + 10;
	const initialTop = Math.max((viewportHeight - dialogueHeight) / 2, 10);
	const initialLeft = Math.max((viewportWidth - dialogueWidth) / 2, 10);
	const dialogWrapper = document.createElement("div");
	dialogWrapper.id = `cctv-dialog-${randomId}`;
	dialogWrapper.className = "overflow-hidden";
	dialogWrapper.style.cssText = `
		position: fixed;
		top: ${initialTop}px;
		left: ${initialLeft}px;
		width: ${dialogueWidth}px;
		height: ${dialogueHeight}px;
		background: white;
		border: 2px solid #666;
		box-shadow: 0 5px 15px rgba(0,0,0,0.3);
		z-index: 9999;
		display: flex;
		flex-direction: column;
	`;

	// 🔹 標題列
	const titleBar = document.createElement("div");
	titleBar.style.cssText = `
		position: relative;
		background: #007bff;
		color: white;
		padding: 8px 10px;
		font-weight: bold;
	`;
	titleBar.textContent = dialog_name;

	// 🔹 按鈕列
	const controlBar = document.createElement("div");
	controlBar.style.cssText = `
		position: absolute;
		right: 3px;
		top: 3px;
	`;

	const closeBtn = document.createElement("button");
	closeBtn.className = "btn btn-sm btn-secondary";
	closeBtn.textContent = "關閉";
	closeBtn.onclick = () => dialogWrapper.remove();

	controlBar.appendChild(closeBtn);
	titleBar.appendChild(controlBar);

	// 🔹 內容區（先顯示載入中）
	const content = document.createElement("div");
	content.className = "overflow-hidden w-100";
	content.style.cssText = "flex:1; display:flex; align-items:center; justify-content:center;";
	content.textContent = "載入中…";

	// 🔹 組合
	dialogWrapper.appendChild(titleBar);
	dialogWrapper.appendChild(content);
	parent.appendChild(dialogWrapper);

	// 🔹 允許使用者拖曳、調整大小 (jQuery UI)
	if (typeof $ === 'function' && $(dialogWrapper).draggable) {
		$(dialogWrapper).draggable({
			handle: titleBar,
			containment: 'window'
		});
		$(dialogWrapper).resizable({
			minWidth: image_size.width,
			minHeight: image_size.height,
			handles: 'all'
		});
	}

	// 🔹 取得 m3u8Url
	fetchPoliceCCTVUrlWithRetry(police_abs_url, 5, 500)
		.then(m3u8Url => {
			console.log("[cctv_dialog - Police] ✅ 成功取得 m3u8Url:", m3u8Url);

			// 🔹 iframe 內容使用 srcdoc 注入 Hls.js 播放器
			const iframeContent = `
		<video id="video" controls autoplay width="100%" height="100%" style="object-fit:contain;"></video>
		<script src="https://cdn.jsdelivr.net/npm/hls.js@latest"><\/script>
		<script>
			var videoSrc = "${m3u8Url}";
			var video = document.getElementById("video");

			if (Hls.isSupported()) {
			var hls = new Hls();
			hls.attachMedia(video);
			hls.on(Hls.Events.MEDIA_ATTACHED, function () {
				hls.loadSource(videoSrc);
			});
			hls.on(Hls.Events.ERROR, function (event, data) {
				console.error("HLS Error:", data);
			});
			} else if (video.canPlayType("application/vnd.apple.mpegurl")) {
			video.src = videoSrc;
			video.addEventListener("loadedmetadata", function() {
				video.play();
			});
			}
		<\/script>
		`;

			// 🔹 將 iframe 注入 content，替換掉載入中
			const viewHtml = `<iframe id="iframe_${randomId}" srcdoc='${iframeContent}' width="${image_size.width}" height="${image_size.height}" frameborder="0" allowfullscreen></iframe>`;
			content.innerHTML = viewHtml;


			// 🔹 新增按鈕列（群組 & 新分頁）
			const groupBtn = document.createElement("button");
			groupBtn.className = "btn btn-primary btn-sm mr-2";
			groupBtn.innerHTML = `
		<a class="cctv-group-window text-white"
			url-type="iframe"
			href="#"
			url-name="警察局-${police_url.substring(25, 35)}"
			url-target="${m3u8Url}"
			is-police="true"
			>
			加入CCTV群組
		</a>`;
			controlBar.insertBefore(groupBtn, closeBtn);

			const newTabBtn = document.createElement("button");
			newTabBtn.id = `newtab_${randomId}`;
			newTabBtn.className = "btn btn-sm btn-success mr-2";
			newTabBtn.textContent = "開新分頁";
			newTabBtn.onclick = () => {
				const newWin = window.open("", "_blank");
				if (newWin) {
					newWin.document.write(`
				<html>
				<head>
					<title>${dialog_name}</title>
				</head>
				<body style="margin:0; padding:0; overflow:hidden;">
					${iframeContent}
				</body>
				</html>
				`);
					newWin.document.close();
				} else {
					alert("請允許彈出視窗才能開啟新分頁！");
				}
			};
			controlBar.insertBefore(newTabBtn, closeBtn);
		})
		.catch(error => {
			console.error("[cctv_dialog - Police] 🚫 獲取 m3u8Url 時發生錯誤:", error);
			content.textContent = "來源端異常，載入失敗，請稍後再試";
		});

	return;
}

function cctv_dialog(dialog_name, url_string, url_type, is_police = false) {

	var randomId = createRandomId(5)
	const image_size = { width: 600, height: 385 }

	if (is_police) {
		console.log("2025.11.12 cctv_dialog police branch")
		cctv_dialog_for_police(dialog_name, url_string)
		return;
	}

	var viewHtml = url_type === 'image' ? `<img src="${url_string}" class="w-100">` :
		`<iframe src="${url_string}" width="100%" height="100%" frameborder="0" title="CCTV檢視"></iframe>`

	$("#cctv_dialog").append(`
        <div
			id="cctv-dialog-${randomId}"
			class="overflow-hidden w-100"
			style="height: calc( 100% - 40px );"
		>
            ${viewHtml}
        </div>`
	)

	$("#cctv-dialog-" + randomId).dialog({
		width: image_size.width,
		height: image_size.height,
		title: dialog_name,
		resize: function (event, ui) { }
	})

	$("#cctv-dialog-" + randomId)
		.prev(".ui-dialog-titlebar")
		.append(
			'<div style="position:absolute; right: 3px; top: 3px">' +
			`<button class="btn btn-primary btn-sm mr-2">
					<a class="cctv-group-window text-white" url-type="image" href="#"
						url-name="${dialog_name}"
						url-target="${url_string}">加入CCTV群組</a>
				</button>` +
			`<button id="newtab_${randomId}" class="btn btn-sm btn-success mr-2">開新分頁</button>` +
			`<button id="close_${randomId}" class="btn btn-sm btn-secondary">關閉</button>` +
			'</div>'
		)
	$("#newtab_" + randomId).click(() => { window.open(url_string, '_blank') })
	$("#close_" + randomId).click(() => { $("#cctv-dialog-" + randomId).dialog("close"); })
}

function cctv_modal(name, url, url_type, is_police = false) {
	if (is_police) {
		cctv_modal_for_police(name, url)
		return
	}
	var viewHtml = `<iframe src="${url}" class="w-100" frameborder="0" title="CCTV檢視" height="500px"></iframe>`
	if (url_type === 'image') {
		viewHtml = `<img src="${url}" class="w-100">`
	}
	var html_string = '<h5>新視窗：<a href="' + url + '" target="_blank">點此</a></h5>' + viewHtml
	$("#modal-cctv .modal-header .modal-title").html(name)
	$("#modal-cctv .modal-body").html(html_string)
	$("#modal-cctv").modal({})
}

function cctv_modal_for_police(name, url) {
	var randomId = createRandomId(5)
	var $cctvModal = $("#modal-cctv")

	// modal-on-modal stacking：第二層 modal 疊高 z-index
	var visibleModalCount = $('.modal:visible').length
	if (visibleModalCount > 0) {
		var zIndex = 1050 + (10 * (visibleModalCount + 1))
		$cctvModal.css('z-index', zIndex)
	} else {
		$cctvModal.css('z-index', '')
	}

	$cctvModal.find('.modal-header .modal-title').html(name)
	$cctvModal.find('.modal-body').html('<div class="text-center p-4">載入中…</div>')

	// 確保 backdrop 也疊高、且關閉內層後外層 scroll lock 不丟失
	$cctvModal.off('shown.bs.modal.policeStack').on('shown.bs.modal.policeStack', function () {
		var modalZ = parseInt($cctvModal.css('z-index'), 10)
		if (modalZ) {
			$('.modal-backdrop').not('.police-stack').last()
				.css('z-index', modalZ - 5)
				.addClass('police-stack')
		}
	})
	$cctvModal.off('hidden.bs.modal.policeStack').on('hidden.bs.modal.policeStack', function () {
		if ($('.modal:visible').length > 0) {
			$('body').addClass('modal-open')
		}
		$cctvModal.css('z-index', '')
	})

	$cctvModal.modal({})

	fetchPoliceCCTVUrlWithRetry(url, 5, 500)
		.then(m3u8Url => {
			console.log('[cctv_modal - Police] m3u8Url:', m3u8Url)
			var iframeContent =
				'<video id="video" controls autoplay width="100%" height="100%" style="object-fit:contain;"></video>' +
				'<script src="https://cdn.jsdelivr.net/npm/hls.js@latest"><\/script>' +
				'<script>' +
				'var videoSrc = "' + m3u8Url + '";' +
				'var video = document.getElementById("video");' +
				'if (Hls.isSupported()) {' +
				'  var hls = new Hls();' +
				'  hls.attachMedia(video);' +
				'  hls.on(Hls.Events.MEDIA_ATTACHED, function () { hls.loadSource(videoSrc); });' +
				'  hls.on(Hls.Events.ERROR, function (event, data) { console.error("HLS Error:", data); });' +
				'} else if (video.canPlayType("application/vnd.apple.mpegurl")) {' +
				'  video.src = videoSrc;' +
				'  video.addEventListener("loadedmetadata", function() { video.play(); });' +
				'}' +
				'<\/script>'

			// 用 DOM API 規避 srcdoc 內嵌 quote 衝突
			var iframe = document.createElement('iframe')
			iframe.id = 'iframe_' + randomId
			iframe.setAttribute('srcdoc', iframeContent)
			iframe.className = 'w-100'
			iframe.frameBorder = 0
			iframe.height = '500'
			iframe.allowFullscreen = true

			// 新分頁版本另用 muted 以繞過瀏覽器 autoplay 限制（about:blank 沒有 media engagement）
			var newTabContent = iframeContent.replace(
				'<video id="video" controls autoplay',
				'<video id="video" controls autoplay muted playsinline'
			)

			// 「新視窗：點此」link 觸發 window.open + document.write，把完整 video + Hls.js HTML 寫進空白新視窗
			var header = document.createElement('h5')
			header.innerHTML = '新視窗：<a href="#" id="newtab_' + randomId + '">點此</a>'
			header.querySelector('#newtab_' + randomId).onclick = function (e) {
				e.preventDefault()
				var newWin = window.open('', '_blank')
				if (newWin) {
					newWin.document.write(
						'<html><head><title>' + name + '</title></head>' +
						'<body style="margin:0; padding:0; overflow:hidden;">' +
						newTabContent +
						'</body></html>'
					)
					newWin.document.close()
				} else {
					alert('請允許彈出視窗才能開啟新分頁！')
				}
			}

			$cctvModal.find('.modal-body').empty()
			$cctvModal.find('.modal-body')[0].appendChild(header)
			$cctvModal.find('.modal-body')[0].appendChild(iframe)
		})
		.catch(error => {
			console.error('[cctv_modal - Police] 解析 m3u8 失敗:', error)
			$cctvModal.find('.modal-body').html('<div class="text-center p-4 text-danger">來源端異常，載入失敗，請稍後再試</div>')
		})
}

function cctv_tv(prop) {
	var result = null,
		geojson_data = new geoJsonTemplate(),
		container = {},
		data;
	if (raw_data["新聞局公共監測CCTV"] == undefined) {
		data = ajax_call(publicPath + "/napi/device/news_cctv");
		data.forEach(function (element) {
			if (!container[String(element.lon) + "," + String(element.lat)]) {
				container[String(element.lon) + "," + String(element.lat)] = []
			}
			container[String(element.lon) + "," + String(element.lat)].push(element)
		})
		Object.keys(container).forEach(eachKey => {
			var coorString = eachKey.split(","),
				thisStnId,
				thisStnAddress,
				thisStatus
			container[eachKey].forEach(el => {
				if (thisStnAddress !== "" && !thisStnAddress) {
					if (el.status !== "<Response [200]>") {
						thisStatus = "中斷"
					} else {
						thisStatus = "正常"
					}
					if (!el.name) {
						el.name = ""
					}
					thisStnId = el.id
					thisStnId = thisStnId.replace("10190", "").replace("10191", "")
					thisStnAddress = el.name
					thisStnAddress = thisStnAddress.replace("水位", "").replace("廣角", "")
				}
			})
			if (thisStnAddress === "") {
				thisStnAddress = "未識別測站"
			}
			geojson_data.features.push({
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [Number(coorString[0]), Number(coorString[1])]
				},
				"properties": {
					"link": container[eachKey],
					"stnId": thisStnId,
					"stnAddress": thisStnAddress,
					"connectionStatus": thisStatus
				}
			})
		})
	} else {
		geojson_data = raw_data["新聞局公共監測CCTV"];
	}
	var cctv_layer = L.geoJSON(geojson_data, {
		filter: (feature, layer) => {
			// if (prop == 'district_office') return feature.properties.stnAddress == '雙泰產業道路'
			// else return feature.properties.stnAddress !== '雙泰產業道路'
			return feature.properties.connectionStatus == "正常"
		},
		pointToLayer: function (feature, latlng) {
			var this_cctv_Icon = 'marker_icon/cctv_TV.png'
			// if (feature.properties.connectionStatus !== "正常") {
			// 	this_cctv_Icon = 'marker_icon/cctv_TV_no.png'
			// }
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: this_cctv_Icon,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	})
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties,
			html_string = ""
		var station_title = this_marker.stnAddress == '雙泰產業道路' ? '區公所水域' : '新聞局公共監測'
		this_marker.link.forEach((el, index) => {
			html_string += `
			<h6>
				<a class="cctv-new-window" url-type="iframe" href="#"
					url-name="${station_title.slice(0, 3)}-${this_marker.stnAddress}"
					url-target="${publicPath + '/napi/device/news_cctv/' + el.id}">鏡頭${(index + 1)}：影像連結</a>
			</h6>
			<button class="btn btn-primary btn-sm">
				<a class="cctv-group-window text-white" url-type="iframe" href="#"
					url-name="${station_title.slice(0, 3)}-${this_marker.stnAddress}"
					url-target="${publicPath + '/napi/device/news_cctv/' + el.id}">加入CCTV群組</a>
			</button>`
		})
		html_string =
			'<h5 class="font-bold-weight">' + station_title + 'CCTV</h5>' +
			'<h6>站名：' + this_marker.stnId + '</h6>' +
			'<h6>地址：' + this_marker.stnAddress + '</h6>' +
			html_string
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, geojson_data];
	return result;
}

// function cctv_wrs(){
// 	var result = null;
// 	var scriptUrl = 'geojson/ntc_wrs/wrs_cctv2.json';
// 	var cctv_Icon = {
// 		iconUrl: '',
// 		iconAnchor:   [15, 32],
// 		iconSize:     [32, 32],
// 		popupAnchor:  [0, -20]
// 	};
// 	var data;
// 	if (raw_data["水利局河川CCTV"] == undefined) {
// 		data = ajax_call(scriptUrl);
// 	} else {
// 		data = raw_data["水利局河川CCTV"];
// 	}
// 	var cctv_layer = L.geoJSON(data, {
// 		pointToLayer: function(feature, latlng) {
//             var this_status;
//             if (raw_data["CCTV狀態"] == undefined || raw_data["CCTV狀態"] == null) {
//                 this_status = "200正常"
//             } else {
//                 this_status = raw_data["CCTV狀態"][feature.properties.name].status;
//             }
//             if (this_status == "200正常") {
//                 cctv_Icon["iconUrl"] = "marker_icon/cctv_wrs.png";
//             } else {
//                 cctv_Icon["iconUrl"] = "marker_icon/cctv_wrs_no.png";
//             }
//             return L.marker(latlng, {
//                 icon: new L.icon(cctv_Icon)
//             }).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>');
//         }
// 	});
// 	cctv_layer.on('touchstart click', onClick);
// 	function onClick(e) {
// 		var this_marker = e.layer.feature.properties;
// 		var html_string = `
//             <h5>水利局河川CCTV影像站</h5>
//             <h6>站名：${this_marker.name}</h6>
//             <h6>
// 				<a class="cctv-new-window" url-type="iframe" href="#"
// 					url-name="水利局河川-${this_marker.name}"
// 					url-target="${this_marker.CCTV}">影像：連結</a>
// 			</h6>
// 			<button class="btn btn-primary btn-sm">
// 				<a class="cctv-group-window text-white" url-type="iframe" href="#"
// 					url-name="水利局河川-${this_marker.name}"
// 					url-target="${this_marker.CCTV}">加入CCTV群組</a>
// 			</button>`
//         setTimeout(function(){
//             $("#this_div").html(html_string);
//         }, 1000);
// 	}
// 	result = [cctv_layer, data];
// 	return result;
// }

function cctv_wrs_hrcm() {
	var result = null;
	var scriptUrl = 'geojson/ntc_wrs/wrs_cctv_hrcm.geojson';
	var cctv_Icon = {
		iconUrl: 'marker_icon/cctv_wrs.png',
		iconAnchor: [15, 32],
		iconSize: [32, 32],
		popupAnchor: [0, -20]
	};
	var data;
	if (raw_data["水利局高灘地CCTV"] == undefined) {
		data = ajax_call(scriptUrl);
	} else {
		data = raw_data["水利局高灘地CCTV"];
	}
	var cctv_layer = L.geoJSON(data, {
		pointToLayer: function (feature, latlng) {
			return L.marker(latlng, {
				icon: new L.icon(cctv_Icon)
			}).bindPopup('<div id="this_div" class="w-300">資料讀取中...</div>');
		}
	});
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties,
			html_string = `
				<h5>水利局高灘地CCTV影像站</h5>
				<h6>攝影機編號：${this_marker.cctv_no}</h6>
				<h6>攝影機位置：${this_marker.location}</h6>
				<h6>
					<a class="cctv-new-window" href="#" url-type="iframe" is-police="true"
						url-name="水利局高灘地CCTV-${this_marker.cctv_no}"
						url-target="${publicPath}/napi/police/hlshtml/${this_marker.CAMID}?jwt=${localStorage.getItem('jwt_token')}">影像：連結</a>
				</h6>
				<button class="btn btn-primary btn-sm">
					<a class="cctv-group-window text-white" url-type="iframe" href="#"
						url-name="水利局高灘地CCTV-${this_marker.cctv_no}"
						url-target="${publicPath}/napi/police/hlshtml/
							${this_marker.CAMID}?jwt=${localStorage.getItem('jwt_token')}">加入CCTV群組</a>
				</button>`
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, data];
	return result;
}

function cctv_swcb() {
	var result = null,
		cctv_Icon = {
			iconUrl: '',
			iconAnchor: [15, 32],
			iconSize: [32, 32],
			popupAnchor: [0, -20]
		},
		res = ajax_call(publicPath + '/napi/swcb/swcb_cctv'),
		data = raw_data["水保署CCTV"] ?? {
			"type": "FeatureCollection",
			"features": res.map(el => {
				return {
					"type": "Feature",
					"geometry": {
						"type": "Point",
						"coordinates": [el.lon_wgs84, el.lat_wgs84]
					},
					"properties": el
				}
			})
		}
	var cctv_layer = L.geoJSON(data, {
		pointToLayer: function (feature, latlng) {
			// var this_status;
			// if (raw_data["CCTV狀態"] == undefined || raw_data["CCTV狀態"] == null) {
			// 	this_status = "200正常"
			// } else {
			// 	this_status = raw_data["CCTV狀態"][feature.properties.name].status;
			// }
			// if (this_status == "200正常") {
			// 	cctv_Icon["iconUrl"] = "marker_icon/cctv_swcb.png";
			// } else {
			// 	cctv_Icon["iconUrl"] = "marker_icon/cctv_swcb_no.png";
			// }
			cctv_Icon["iconUrl"] = "marker_icon/cctv_swcb.png"
			return L.marker(latlng, {
				icon: new L.icon(cctv_Icon)
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	});
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties;
		var html_string = `
			<h5 class="font-bold-weight">水保署CCTV(土石流觀測站)</h5>
			<h6>站名：${this_marker.station_name}</h6>
			<h6>地址：${this_marker.location_name}</h6>
            <h6>
				<a class="cctv-new-window" url-type="iframe" href="#"
				url-name="水保署-${this_marker.station_name}"
				url-target="${this_marker.cctv_url}">影像：連結</a>
			</h6>
			<button class="btn btn-primary btn-sm">
				<a class="cctv-group-window text-white" url-type="iframe" href="#"
					url-name="水保署-${this_marker.station_name}"
					url-target="${this_marker.cctv_url}">加入CCTV群組</a>
			</button>`
		// <h6><a href="https://dfm.swcb.gov.tw/dfm/ViewStation.aspx?StationID=${this_marker.ID}" target="_blank">土石流觀測站：外部連結</a></h6>
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, data];
	return result;
}

function cctv_wra() {
	var result = null,
		rawData,
		cctv_Icon = new L.icon({
			iconUrl: 'marker_icon/cctv_wrap.png',
			iconAnchor: [15, 32],
			iconSize: [32, 32],
			popupAnchor: [0, -20]
		}),
		data = new geoJsonTemplate()
	if (raw_data["水利署CCTV"] == undefined) {
		rawData = ajax_call(publicPath + '/napi/wra/wra_cctv')
		rawData.forEach(function (element) {
			element.address = element.county_name + element.town_name
			data.features.push({
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [element.lon_wgs84, element.lat_wgs84]
				},
				"properties": element
			})
		})
	} else {
		data = raw_data["水利署CCTV"];
	}
	var cctv_layer = L.geoJSON(data, {
		pointToLayer: function (feature, latlng) {
			return L.marker(latlng, {
				icon: cctv_Icon
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	});
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties,
			html_string = `
				<h5 class="font-bold-weight">水利署CCTV觀測站</h5>
				<h6>站名：${this_marker.station_name}</h6>
				<h6>流域：${this_marker.basin_name}</h6>
				<h6>縣市：${this_marker.county_name}</h6>
				<h6>行政區：${this_marker.town_name}</h6>
                <h6>
					<a class="cctv-new-window" url-type="image" href="#"
						url-name="水利署-${this_marker.station_name}"
						url-target="${this_marker.cctv_url}">影像：連結</a>
				</h6>
				<button class="btn btn-primary btn-sm">
					<a class="cctv-group-window text-white" url-type="image" href="#"
						url-name="水利署-${this_marker.station_name}"
						url-target="${this_marker.cctv_url}">加入CCTV群組</a>
				</button>`
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, data];
	return result;
}

function cctv_traffic() {
	var result = null,
		rawData,
		data = new geoJsonTemplate()
	if (raw_data["交通局CCTV"] == undefined) {
		rawData = ajax_call(publicPath + '/napi/traffic/traffic_cctv');
		rawData.forEach(function (element) {
			data.features.push({
				"type": "Feature",
				"geometry": {
					"type": "Point",
					"coordinates": [element.lon_wgs84, element.lat_wgs84]
				},
				"properties": element
			})
		})
	} else {
		data = raw_data["交通局CCTV"];
	}
	var cctv_layer = L.geoJSON(data, {
		pointToLayer: function (feature, latlng) {
			let this_cctv_Icon = "marker_icon/cctv_traffic.png"
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: this_cctv_Icon,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	});
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties;
		var html_string =
			'<h5 class="font-bold-weight">交通局CCTV影像站</h5>' +
			'<h6>編號：' + this_marker.station_id + '</h6>' +
			'<h6>地址：' + this_marker.location_name + '</h6>' +
			'<h6><a href="' + this_marker.cctv_url + '" target="_blank">影像：外部連結</a></h6>';
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, data];
	return result;
}

function cctv_thb() {
	var result = null,
		res = ajax_call(publicPath + '/napi/thb/thb_cctv'),
		data = raw_data["公路局CCTV"] ?? {
			"type": "FeatureCollection",
			"features": res.map(el => {
				return {
					"type": "Feature",
					"geometry": {
						"type": "Point",
						"coordinates": [el.lon_wgs84, el.lat_wgs84]
					},
					"properties": el
				}
			})
		}

	var cctv_layer = L.geoJSON(data, {
		pointToLayer: function (feature, latlng) {
			// var this_status, this_cctv_Icon
			// if (raw_data["CCTV狀態"] == undefined || raw_data["CCTV狀態"] == null) {
			// 	this_status = "200正常"
			// } else {
			// 	try {
			// 		this_status = raw_data["CCTV狀態"][feature.properties.stakenumber].status;
			// 	} catch (e) {
			// 		this_status = "無法判斷"
			// 	}
			// }
			// if (this_status == "200正常" || this_status == "無法判斷") {
			// 	this_cctv_Icon = "marker_icon/thb_cctv.png";
			// } else {
			// 	this_cctv_Icon = "marker_icon/thb_cctv_no.png";
			// }
			let this_cctv_Icon = "marker_icon/thb_cctv.png"
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: this_cctv_Icon,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	});
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties;
		var html_string = `
			<h5 class="font-bold-weight">公路局CCTV影像站</h5>
			<h6>地址：${this_marker.station_name}</h6>
            <h6>
				<a class="cctv-new-window" url-type="image" href="#"
					url-name="公路局-${this_marker.station_name}"
					url-target="${this_marker.cctv_url}">影像：連結</a>
			</h6>
			<button class="btn btn-primary btn-sm">
				<a class="cctv-group-window text-white" url-type="image" href="#"
					url-name="公路局-${this_marker.station_name}"
					url-target="${this_marker.cctv_url}">加入CCTV群組</a>
			</button>`
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, data];
	return result;
}

function cctv_freeway() {
	var result = null,
		res = ajax_call(publicPath + '/napi/freeway/freeway_cctv'),
		data = raw_data["高公局CCTV"] ?? {
			"type": "FeatureCollection",
			"features": res.map(el => {
				return {
					"type": "Feature",
					"geometry": {
						"type": "Point",
						"coordinates": [el.lon_wgs84, el.lat_wgs84]
					},
					"properties": {
						...el,
						location_name: el.town_name + el.observe_value + el.location_mile
					}
				}
			})
		}

	var cctv_layer = L.geoJSON(data, {
		pointToLayer: function (feature, latlng) {
			let this_cctv_Icon = "marker_icon/cctv_freeway.png"
			return L.canvasMarker(latlng, {
				radius: 15,
				img: {
					url: this_cctv_Icon,
					size: [32, 32],
					offset: { x: 0, y: 0 },
				}
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	});
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties;
		var html_string = `
			<h5 class="font-bold-weight">高公局CCTV影像站</h5>
			<h6>名稱：${this_marker.observe_value}${this_marker.location_mile}</h6>
			<h6>編號：${this_marker.station_id}</h6>
            <h6>
				<a class="cctv-new-window" url-type="image" href="#"
				url-name="高公局-${this_marker.observe_value}${this_marker.location_mile}"
				url-target="${this_marker.cctv_url}">影像：連結</a>
			</h6>
			<button class="btn btn-primary btn-sm">
				<a class="cctv-group-window text-white" url-type="image" href="#"
					url-name="高公局-${this_marker.observe_value}${this_marker.location_mile}"
					url-target="${this_marker.cctv_url}">加入CCTV群組</a>
			</button>`
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, data];
	return result;
}

function cctv_iroad() {
	var data = ajax_call(publicPath + "/napi/device/iroad_cctv"),
		geo_json = turf.featureCollection([]),
		result
	if (data) {
		if (data.IsSuccessful === true) {
			var cctvList = {}
			data.Data.forEach(el => {
				cctvList[el.STREAM_URL] = el
			})
			Object.values(cctvList).forEach((el, index) => {
				var wgsCoor = proj4(EPSG3826, EPSG4326, [Number(el.LocX), Number(el.LocY)])
				el.name = "緊急搶修/臨時事件" + (index + 1)
				geo_json.features.push({
					"type": "Feature",
					"geometry": {
						"type": "Point",
						"coordinates": wgsCoor
					},
					"properties": el
				})
			})
		}
	}
	var cctv_layer = L.geoJSON(geo_json, {
		pointToLayer: function (feature, latlng) {
			return L.marker(latlng, {
				icon: new L.icon({
					iconUrl: 'marker_icon/cctv_iroad.png',
					iconAnchor: [15, 32],
					iconSize: [32, 32],
					popupAnchor: [0, -20]
				})
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	}).on('touchstart click', function (e) {
		var this_marker = e.layer.feature.properties,
			url = publicPath + '/napi/normal/hlshtml?jwt=' + localStorage.getItem('jwt_token') + '&hlsurl=' + this_marker["STREAM_URL"]
		var html_string = `
			<h5 class="font-bold-weight">道路管理中心CCTV</h5>
            <h6>
				<a class="cctv-new-window" url-type="iframe" href="#"
					url-name="道路管理中心-${this_marker.name}" url-target="${url}">
					影像：連結
				</a>
			</h6>
			<button class="btn btn-primary btn-sm">
				<a class="cctv-group-window text-white" url-type="iframe" href="#"
					url-name="道路管理中心-${this_marker.name}"
					url-target="${url}">加入CCTV群組</a>
			</button>`
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	})
	result = [cctv_layer, geo_json];
	return result;
}

function cctv_underpass() {
	var result = null,
		rawData,
		data = new geoJsonTemplate()
	if (raw_data["車行地下道CCTV"] == undefined) {
		rawData = ajax_call(publicPath + '/napi/underpass-cctv');
		if (rawData) {
			rawData.forEach(function (element) {
				// Only include items that have cctv_url
				if (element.cctv1) {
					data.features.push({
						"type": "Feature",
						"geometry": {
							"type": "Point",
							"coordinates": [element.lng, element.lat]
						},
						"properties": element
					})
				}
			})
		}
	} else {
		data = raw_data["車行地下道CCTV"];
	}
	var cctv_Icon = {
		iconUrl: 'marker_icon/cctv_wrs.png',
		iconAnchor: [15, 32],
		iconSize: [32, 32],
		popupAnchor: [0, -20]
	};
	var cctv_layer = L.geoJSON(data, {
		pointToLayer: function (feature, latlng) {
			return L.marker(latlng, {
				icon: new L.icon(cctv_Icon)
			}).bindPopup('<div id="this_div" class="w-250">資料讀取中...</div>')
		}
	});
	cctv_layer.on('touchstart click', onClick);
	function onClick(e) {
		var this_marker = e.layer.feature.properties;
		var html_string = `
			<h5 class="font-bold-weight">車行地下道CCTV影像站</h5>
			<h6>名稱： ${this_marker.name} </h6>
			<h6><a href="${this_marker.cctv1}" target="_blank">影像：外部連結</a></h6>
			${this_marker.cctv2
				? `<h6><a href="${this_marker.cctv2}" target="_blank">影像2：外部連結</a></h6>`
				: ''
			}
		`;
		setTimeout(function () {
			$("#this_div").html(html_string);
		}, 1000);
	}
	result = [cctv_layer, data];
	return result;
}

function cctv_police(map_object) {
	var trigger_method = null;
	isiOS ? ((trigger_method = "mouseover")) : ((trigger_method = "click"));
	var this_layer = L.tileLayer.wms(publicPath + '/cloud/geoserver/edp2/wms?', {
		layers: 'edp2:police_cctv',
		transparent: true,
		format: 'image/png',
		maxZoom: 22,
		pane: "high-zindex-wms-layer"
	})
	map_object.addEventListener('touchstart click', function (event) {
		var bboxString = wmsQueryBBoxString(event),
			zoomLevel = event.target._zoom,
			query_url = publicPath + "/cloud/geoserver/edp2/ows?service=WFS&version=1.0.0&request=GetFeature&typeName=edp2%3Apolice_cctv&cql_filter=WITHIN(geom,%20POLYGON((" + bboxString + ")))&outputFormat=application%2Fjson"
		if (zoomLevel >= 15) {
			$.ajax({
				url: query_url,
				type: 'get',
				dataType: 'json'
			}).done(function (data) {
				if (data.features.length != 0) {
					var popup_html_string = "";
					data.features.forEach(function (feature) {
						var stationName = feature.properties.name.split(".")[1] ? feature.properties.name.split(".")[1] : feature.properties.name
						popup_html_string += `
							<h6>
								<a class="cctv-new-window" url-type="iframe" href="#" is-police="true"
									url-name="警察局-${stationName}"
									url-target="${publicPath}/napi/police/hlshtml/${feature.properties.id}?jwt=${localStorage.getItem('jwt_token')}"
									onclick="return window.handlePoliceCctvClick('警察局-${stationName}', jwt=${localStorage.getItem('jwt_token')}', this);">
									${stationName}</a>
							</h6>
							<button class="btn btn-primary btn-sm">
								<a class="cctv-group-window text-white" url-type="iframe" href="#" is-police="true"
									url-name="警察局-${stationName}"
									url-target="${publicPath}/napi/police/hlshtml/${feature.properties.id}?jwt=${localStorage.getItem('jwt_token')}">
									加入CCTV群組</a>
							</button>`
					});
					var popup = L.popup()
						.setLatLng([event.latlng.lat, event.latlng.lng])
						.setContent(
							'<div class="w-300">' +
							'<h5 class="font-bold-weight">警察局CCTV</h5>' +
							'<h6>此處有' + data.features.length + '支</h6>' +
							popup_html_string +
							'</div>'
						).openOn(map_object);
				};
			});
		}
	});
	return [this_layer];
}